import { Select } from "antd";
import "./styles.scss";
export default function DBSelect(props) {
    return (
        <div>
            <Select
                {...props}
                className="db-linear-select"
                dropdownStyle={{ zIndex: 999999 }}
            />
        </div>
    );
}
